import { Navigate } from "react-router-dom";
import LocalityPage from "../components/LocalityPage";
import { ARRONDISSEMENTS } from "../data/site";
import { ARR_QUARTIERS, ARR_NEARBY } from "../data/zones";

export default function Arrondissement({ numero }) {
    const n = Number(numero);
    const arr = ARRONDISSEMENTS.find((a) => a.n === n);
    if (!arr) return <Navigate to="/" replace />;

    const quartiers = ARR_QUARTIERS[n] || [`Tous les quartiers du ${arr.label} arrondissement`];
    const nearby = ARR_NEARBY[n] || [];

    const q0 = quartiers[0] || arr.label;
    const q1 = quartiers[1] || arr.label;
    const q2 = quartiers[2] || arr.label;
    const nearbyStr = nearby.slice(0, 4).join(", ");
    const nearbyFull = nearby.slice(0, 6).join(", ");

    return (
        <LocalityPage
            name={arr.label}
            cp={arr.cp}
            kicker={`Arrondissement — ${arr.cp}`}
            crumb={arr.label}
            introTitle={`Serrurier de confiance dans le ${arr.label} arrondissement`}
            introP1={`Porte claquée à ${q0}, serrure forcée près de ${q1} ou blindage à poser d'urgence côté ${q2} ? Nos artisans serruriers couvrent l'ensemble du ${arr.label} arrondissement (${arr.cp}) : ouverture de porte sans casse à partir de 60 € TTC, changement de cylindre, blindage de porte A2P certifié, double de clé — le tout avec devis gratuit communiqué par téléphone avant chaque intervention. Agréés par les assurances habitation depuis 1985.`}
            introP2={`Nos artisans interviennent dans tous les quartiers du ${arr.label} — ${quartiers.slice(0, 4).join(", ")}… — et couvrent également les secteurs voisins : ${nearbyFull}. Disponibles 24h/24, 7j/7, y compris les nuits, les week-ends et les jours fériés — délai d'intervention garanti en 30 minutes.`}
            chips={quartiers}
            others={ARRONDISSEMENTS.filter((a) => a.n !== n).map((a) => ({ label: `Serrurier ${a.label}`, to: `/serrurier-paris-${a.n}` }))}
            path={`/serrurier-paris-${n}`}
            seoTitle={`Serrurier ${arr.label} (${arr.cp}) — Urgence 24/7 · Intervention 30 min · Devis Gratuit`}
            seoDesc={`Serrurier ${arr.label} (${quartiers.slice(0, 3).join(", ")}) : ouverture de porte 60 € TTC, changement de serrure, blindage. Artisan agréé assurance, chez vous en 30 min dans le ${arr.cp}, 24h/24. ☎ 06 25 25 86 19`}
        />
    );
}
